module.exports = __webpack_public_path__ + "img/default-stared.711c88e5.png";